import React from 'react'
import { useTranslation } from 'react-i18next';

import {
  sponsoredByLogo,
  supportedByLogo,
  ticketingByLogo,
  djPerformByLogo,
  presentedByLogo,
  communityPartnerLogo,
  mediaByLogo,
  venueByLogo
} from 'utils/constants/data';

function OurSponsors({
  landingPage
}) {

  const { t } = useTranslation()

  const sponsors = {
    sponsoredBy: (
      <div className="grid grid-cols-3 gap-4 items-center place-items-center app-animation-translate-start">
        {
          sponsoredByLogo && sponsoredByLogo.map((logo) => {
            return <img src={logo && logo.image_url} className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain" alt="client-logo" />
          })
        }
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    ticketingSytem: (
      <div className="grid grid-cols-1 gap-4 items-center place-items-center app-animation-translate-start">
        {
          ticketingByLogo && ticketingByLogo.map((logo) => {
            return <img src={logo && logo.image_url} className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain" alt="client-logo" />
          })
        }
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    djPerformance: (
      <div className="grid grid-cols-1 gap-4 items-center place-items-center app-animation-translate-start">
        {
          djPerformByLogo && djPerformByLogo.map((logo) => {
            return <img src={logo && logo.image_url} className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain" alt="client-logo" />
          })
        }
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    venuePartner: (
      <div className="grid grid-cols-1 gap-4 items-center place-items-center app-animation-translate-start">
        {
          venueByLogo && venueByLogo.map((logo) => {
            return <img src={logo && logo.image_url} className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain" alt="client-logo" />
          })
        }
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    mediaPartner: (
      <div className="grid grid-cols-1 gap-4 items-center place-items-center app-animation-translate-start">
        {
          mediaByLogo && mediaByLogo.map((logo) => {
            return <img src={logo && logo.image_url} className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain" alt="client-logo" />
          })
        }
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    supportedBy: (
      <div className="grid grid-cols-4 gap-4 items-center place-items-center app-animation-translate-start">
        {
          supportedByLogo && supportedByLogo.map((logo) => {
            return <img src={logo && logo.image_url} className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain" alt="client-logo" />
          })
        }
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    presentedBy: (
      <div className="grid grid-cols-2 gap-4 items-center place-items-center app-animation-translate-start">
        {
          presentedByLogo && presentedByLogo.map((logo) => {
            return <img src={logo && logo.image_url} className="h-full w-full max-w-[150px] sm:max-w-[250px] object-contain" alt="client-logo" />
          })
        }
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    ),
    communityPartner: (
      <div className="grid grid-cols-4 gap-4 items-center place-items-center app-animation-translate-start">
        {
          communityPartnerLogo && communityPartnerLogo.map((logo) => {
            return <img src={logo && logo.image_url} className="h-full w-full max-w-[150px] sm:max-w-[300px] object-contain" alt="client-logo" />
          })
        }
        {/* <p><b>{t('manyMore')}</b></p> */}
      </div>
    )
  }

  return (
    <div>
      {!landingPage && (
        <section>
          <div className='relative'>
            <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/1e2d76398e39de9257c7d3d5ad558638356bcb4c05d46b1ca2840746b30e64dce30e7a8fa63c85f81d5942e3b278d4c33e35e7b034bd70b18ee46dd76e1dec7e1263bc5f038fbe9091d0704179d66d3665aa350ede4a45479771e322542edd80597fd529d85c53647fd8ed15b46c583eba9a2cfc8b8b4392a5f9/file-1745821144382.jpeg" alt="main" className='w-full max-h-40 sm:max-h-60 object-cover object-center' />
            <div className='absolute top-0 bottom-0 left-0 right-0 bg-black/60 text-white'>
              <div className='app-main-container flex flex-col justify-center items-center h-full gap-4 sm:gap-8'>
                <p className='text-2xl md:text-3xl/[3rem] lg:text-4xl/[3rem] max-w-md lg:max-w-xl px-8 font-bold text-center app-animation-translate-start'>{t('ourSponsorsBanner')}</p>
              </div>
            </div>
          </div>
        </section>
      )}
      <section>
        <div className='app-main-container space-y-8'>
          <p className='text-xl sm:text-2xl font-bold text-app-blue text-center app-animation-translate-start'>
            {t('sponsoredBy')}
          </p>
          <div className='text-app-blue text-sm sm:text-base max-w-2xl mx-auto'>{sponsors.sponsoredBy}</div>
        </div>
      </section>
      <section>
        <div className='app-main-container space-y-8'>
          <p className='text-xl sm:text-2xl font-bold text-app-blue text-center app-animation-translate-start'>
            {t('eTicketingSystem')}
          </p>
          <div className='text-app-blue text-sm sm:text-base max-w-2xl mx-auto'>{sponsors.ticketingSytem}</div>
        </div>
      </section>
      {/* <section>
        <div className='app-main-container space-y-8'>
          <p className='text-xl sm:text-2xl font-bold text-app-blue text-center app-animation-translate-start'>
            {t('djPerformance')}
          </p>
          <div className='text-app-blue text-sm sm:text-base max-w-2xl mx-auto'>{sponsors.djPerformance}</div>
        </div>
      </section> */}
      <section>
        <div className='app-main-container space-y-8'>
          <p className='text-xl sm:text-2xl font-bold text-app-blue text-center app-animation-translate-start'>
            {t('venuePartner')}
          </p>
          <div className='text-app-blue text-sm sm:text-base max-w-2xl mx-auto'>{sponsors.venuePartner}</div>
        </div>
      </section>
      <section>
        <div className='app-main-container space-y-8'>
          <p className='text-xl sm:text-2xl font-bold text-app-blue text-center app-animation-translate-start'>
            {t('mediaPartner')}
          </p>
          <div className='text-app-blue text-sm sm:text-base max-w-2xl mx-auto'>{sponsors.mediaPartner}</div>
        </div>
      </section>
      {/* <section>
        <div className='app-main-container space-y-8'>
          <p className='text-xl sm:text-2xl font-bold text-app-blue text-center app-animation-translate-start'>
            {t('supportedBy')}
          </p>
          <div className='text-app-blue text-sm sm:text-base max-w-2xl mx-auto'>{sponsors.supportedBy}</div>
        </div>
      </section> */}
      <section>
        <div className='app-main-container space-y-8'>
          <p className='text-xl sm:text-2xl font-bold text-app-blue text-center app-animation-translate-start'>
            {t('presentedBy')}
          </p>
          <div className='text-app-blue text-sm sm:text-base max-w-2xl mx-auto'>{sponsors.presentedBy}</div>
        </div>
      </section>
      {/* <section>
        <div className='app-main-container space-y-8'>
          <p className='text-xl sm:text-2xl font-bold text-app-blue text-center app-animation-translate-start'>
            {t('communityPartner')}
          </p>
          <div className='text-app-blue text-sm sm:text-base max-w-2xl mx-auto'>{sponsors.communityPartner}</div>
        </div>
      </section> */}
    </div>
  )

}

export default OurSponsors